import firebase from 'firebase/app';
import 'firebase/database';

firebase.initializeApp({
  apiKey: "AIzaSyBsYTs6ylQne_P16M46NS1tts0l37xNEmk",
  authDomain: "place-4ab39.firebaseapp.com",
  projectId: "place-4ab39",
  storageBucket: "place-4ab39.firebasestorage.app",
  messagingSenderId: "289214639262",
  appId: "1:289214639262:web:64814ed372ac46ad7e1f8f",
  measurementId: "G-5GSYLZEYL9",
  databaseURL: "https://place-4ab39-default-rtdb.firebaseio.com",
});

const database = firebase.app().database();

export default database;
